module.exports = __webpack_public_path__ + "img/KBank.29c2c6f.png";